// demoData.js — fixtures for the 5-minute Comprehend Live demo.
// Live voice + live agent over this scripted data (decided 6/9/26): the
// demo fakes DATA, never behavior. See docs/comprehend-live-demo-guide.md.

export const IDS = {
  annie: 90001,
  janie: 90002,
  jimmy: 90011,
  sarah: 90012,
  marcus: 90013,
  elena: 90014,
  derek: 90015,
  priya: 90016,
  tom: 90017,
  grace: 90018,
  omar: 90019,
  bella: 90020,
};

export const DEMO_PATIENTS = [
  { firstName: 'Annie', lastName: 'Park', uid: 80001 },
  { firstName: 'Janie', lastName: 'Wilson', uid: 80002 },
  { firstName: 'Jimmy', lastName: 'Rodriguez', uid: 80011 },
  { firstName: 'Sarah', lastName: 'Chen', uid: 80012 },
  { firstName: 'Marcus', lastName: 'Webb', uid: 80013 },
  { firstName: 'Elena', lastName: 'Diaz', uid: 80014 },
  { firstName: 'Derek', lastName: 'Hall', uid: 80015 },
  { firstName: 'Priya', lastName: 'Patel', uid: 80016 },
  { firstName: 'Tom', lastName: 'Nguyen', uid: 80017 },
  { firstName: 'Grace', lastName: 'Liu', uid: 80018 },
  { firstName: 'Omar', lastName: 'Farouk', uid: 80019 },
  { firstName: 'Bella', lastName: 'Torres', uid: 80020 },
];

const yesterday = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  d.setHours(14, 0, 0, 0);
  return d.toISOString();
};

// Demo times are whole-minute offsets from t0 (which setupDemo floors to the
// minute) so visits always land exactly on a minute — never between one.
const MIN = 60 * 1000;

export const buildDemoSessions = (t0) => [
  {
    conversationId: IDS.annie,
    name: 'Annie Park - Daily Note',
    patientName: 'Annie Park',
    group: 80001,
    createdAt: yesterday(),
    isToday: false,
    status: 'Transcription Complete!',
    recording: false,
    score: 84,
    grade: 'A',
  },
  {
    conversationId: IDS.janie,
    name: 'Janie Wilson - Daily Note',
    patientName: 'Janie Wilson',
    group: 80002,
    createdAt: yesterday(),
    isToday: false,
    status: 'Transcription Complete!',
    recording: false,
    score: 58,
    grade: 'C',
  },
  {
    conversationId: IDS.jimmy,
    name: 'Jimmy Rodriguez - Daily Note',
    patientName: 'Jimmy Rodriguez',
    group: 80011,
    createdAt: new Date(t0 + 1 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.sarah,
    name: 'Sarah Chen - Daily Note',
    patientName: 'Sarah Chen',
    group: 80012,
    createdAt: new Date(t0 + 1 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.marcus,
    name: 'Marcus Webb - Progress Note',
    patientName: 'Marcus Webb',
    group: 80013,
    createdAt: new Date(t0 + 3 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.elena,
    name: 'Elena Diaz - Daily Note',
    patientName: 'Elena Diaz',
    group: 80014,
    createdAt: new Date(t0 + 3 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  // Already in session when the demo loads — ending soon.
  {
    conversationId: IDS.derek,
    name: 'Derek Hall - Daily Note',
    patientName: 'Derek Hall',
    group: 80015,
    createdAt: new Date(t0 - 2 * MIN).toISOString(),
    isToday: true,
    status: 'Recording',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.priya,
    name: 'Priya Patel - Daily Note',
    patientName: 'Priya Patel',
    group: 80016,
    createdAt: new Date(t0 - 2 * MIN).toISOString(),
    isToday: true,
    status: 'Recording',
    recording: false,
    score: null,
    grade: '--',
  },
  // Rest of the day: a 1:1 eval, then a 3:1 group block.
  {
    conversationId: IDS.tom,
    name: 'Tom Nguyen - Eval',
    patientName: 'Tom Nguyen',
    group: 80017,
    createdAt: new Date(t0 + 5 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.grace,
    name: 'Grace Liu - Daily Note',
    patientName: 'Grace Liu',
    group: 80018,
    createdAt: new Date(t0 + 7 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.omar,
    name: 'Omar Farouk - Daily Note',
    patientName: 'Omar Farouk',
    group: 80019,
    createdAt: new Date(t0 + 7 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
  {
    conversationId: IDS.bella,
    name: 'Bella Torres - Daily Note',
    patientName: 'Bella Torres',
    group: 80020,
    createdAt: new Date(t0 + 7 * MIN).toISOString(),
    isToday: true,
    status: 'Scheduled',
    recording: false,
    score: null,
    grade: '--',
  },
];

// Compressed day on whole minutes: a pair mid-session at load (ends +1 min),
// two back-to-back 2:1 slots, then a 1:1 eval and a 3:1 group block.
export const buildDemoSchedule = (t0) => [
  {
    slotId: 'slot0',
    start: new Date(t0 - 2 * MIN),
    end: new Date(t0 + 1 * MIN),
    patients: [
      { patientName: 'Derek Hall', group: 80015, conversationId: IDS.derek },
      { patientName: 'Priya Patel', group: 80016, conversationId: IDS.priya },
    ],
  },
  {
    slotId: 'slot1',
    start: new Date(t0 + 1 * MIN),
    end: new Date(t0 + 3 * MIN),
    patients: [
      {
        patientName: 'Jimmy Rodriguez',
        group: 80011,
        conversationId: IDS.jimmy,
      },
      { patientName: 'Sarah Chen', group: 80012, conversationId: IDS.sarah },
    ],
  },
  {
    slotId: 'slot2',
    start: new Date(t0 + 3 * MIN),
    end: new Date(t0 + 5 * MIN),
    patients: [
      { patientName: 'Marcus Webb', group: 80013, conversationId: IDS.marcus },
      { patientName: 'Elena Diaz', group: 80014, conversationId: IDS.elena },
    ],
  },
  {
    slotId: 'slot3-oneonone',
    start: new Date(t0 + 5 * MIN),
    end: new Date(t0 + 7 * MIN),
    patients: [
      { patientName: 'Tom Nguyen', group: 80017, conversationId: IDS.tom },
    ],
  },
  {
    slotId: 'slot4-group',
    start: new Date(t0 + 7 * MIN),
    end: new Date(t0 + 9 * MIN),
    patients: [
      { patientName: 'Grace Liu', group: 80018, conversationId: IDS.grace },
      { patientName: 'Omar Farouk', group: 80019, conversationId: IDS.omar },
      { patientName: 'Bella Torres', group: 80020, conversationId: IDS.bella },
    ],
  },
];

export const DEMO_HISTORIES = {
  80001: {
    patientName: 'Annie Park',
    diagnosis: 'Post-op ACL reconstruction, right knee (8 weeks post-op)',
    visitsCompleted: 9,
    plannedVisits: 16,
    lastVisit:
      'Yesterday: quad sets, SLR x3, leg press progressed to 90 lbs. Knee flexion AROM 125°, extension 0°. Reports 2/10 pain after activity, swelling resolved.',
    goals: 'Return to recreational soccer by month 6; full ROM achieved.',
    hep: 'Daily quad/hamstring program — adherent.',
    flags: 'Cleared for light jogging at next MD follow-up (next week).',
  },
  80002: {
    patientName: 'Janie Wilson',
    diagnosis: 'Cervical radiculopathy, left C6',
    visitsCompleted: 4,
    plannedVisits: 12,
    lastVisit:
      'Yesterday: manual traction, deep neck flexor training, postural re-ed. Symptoms centralizing.',
    goals: 'Return to desk work without symptom flare.',
    hep: 'Chin tucks + median nerve glides, 2x daily.',
    flags: 'Yesterday’s note scored C (58) — ROM not documented.',
  },
  80011: {
    patientName: 'Jimmy Rodriguez',
    diagnosis: 'Right shoulder impingement syndrome, 6 weeks',
    visitsCompleted: 5,
    plannedVisits: 12,
    lastVisit:
      'Last week: flexion AROM 105°, abduction 90°, painful arc 70–110°. Scaption strengthening, posterior capsule stretching.',
    goals: 'Overhead reach to top shelf pain-free; return to rec softball.',
    hep: 'Pendulums + scaption raises daily.',
    rtm: {
      enrolled: true,
      adherence: 'LOW — 3 missed sessions this week (was 95% adherent before)',
      lastReading: 'Pain reported 4/10 during home exercises on Tuesday',
    },
    flags:
      'Limited progress on ROM in last two visits; consider differential for adhesive capsulitis (frozen shoulder).',
  },
  80012: {
    patientName: 'Sarah Chen',
    diagnosis: 'Chronic low back pain, flexion intolerant',
    visitsCompleted: 7,
    plannedVisits: 10,
    lastVisit:
      'McGill big-3 progression, hip hinge training. 3/10 → 1/10 pain.',
    goals: 'Lift toddler without flare.',
    hep: 'Big-3 daily — adherent.',
    flags: 'Visit 10 approaching — progress note due.',
  },
  80013: {
    patientName: 'Marcus Webb',
    diagnosis: 'Left ankle sprain grade II, return-to-sport phase',
    visitsCompleted: 9,
    plannedVisits: 10,
    lastVisit: 'Hop testing 85% LSI; cutting drills introduced.',
    goals: 'Return to basketball.',
    hep: 'Balance board + calf raises.',
    flags: 'Visit 10 today — progress note due.',
  },
  80014: {
    patientName: 'Elena Diaz',
    diagnosis: 'Total knee arthroplasty, left (4 weeks post-op)',
    visitsCompleted: 6,
    plannedVisits: 20,
    lastVisit: 'Flexion 95°, extension -3°. Gait training, patellar mobs.',
    goals: 'Community ambulation without assistive device.',
    hep: 'Heel slides + extension hangs, 3x daily.',
    flags: null,
  },
  80015: {
    patientName: 'Derek Hall',
    diagnosis: 'Rotator cuff repair, right (12 weeks post-op)',
    visitsCompleted: 14,
    plannedVisits: 24,
    lastVisit: 'Isometrics progressed to bands; flexion AROM 150°.',
    goals: 'Return to overhead carpentry work.',
    hep: 'Band ER/IR + scapular series daily — adherent.',
    flags: null,
  },
  80016: {
    patientName: 'Priya Patel',
    diagnosis: 'Plantar fasciitis, left, chronic',
    visitsCompleted: 3,
    plannedVisits: 8,
    lastVisit: 'Calf eccentric loading, first-step pain 6/10 → 4/10.',
    goals: 'Morning first-step pain under 2/10; resume 5k training.',
    hep: 'Towel stretches + frozen bottle rolls, 2x daily.',
    flags: 'Night splint discussed — patient undecided.',
  },
  80017: {
    patientName: 'Tom Nguyen',
    diagnosis: 'New eval — right knee pain, suspected meniscal',
    visitsCompleted: 0,
    plannedVisits: 1,
    lastVisit: 'None — initial evaluation today (1:1 slot).',
    goals: 'Establish diagnosis and plan of care.',
    hep: 'TBD at eval.',
    flags: 'Referral notes mention locking episodes — screen carefully.',
  },
  80018: {
    patientName: 'Grace Liu',
    diagnosis: 'Hip OA, conservative management',
    visitsCompleted: 5,
    plannedVisits: 12,
    lastVisit: 'Hip abductor strengthening; gait speed improving.',
    goals: 'Walk 30 min without ache.',
    hep: 'Clamshells + bridges daily.',
    flags: null,
  },
  80019: {
    patientName: 'Omar Farouk',
    diagnosis: 'Lumbar strain, return-to-work program',
    visitsCompleted: 7,
    plannedVisits: 10,
    lastVisit: 'Lifting mechanics circuit; tolerated 40 lbs floor-to-waist.',
    goals: 'Full duty warehouse clearance.',
    hep: 'McGill big-3 + hip hinge practice.',
    flags: 'Visit 10 approaching — progress note due.',
  },
  80020: {
    patientName: 'Bella Torres',
    diagnosis: 'ACL reconstruction (16 weeks post-op)',
    visitsCompleted: 18,
    plannedVisits: 30,
    lastVisit: 'Single-leg press symmetric; intro plyo prep.',
    goals: 'Return to club soccer at 9 months.',
    hep: 'Strength program 3x/week.',
    flags: null,
  },
};

export const DEMO_DETAILS = {
  [IDS.annie]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 1850,
    score: 84,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'Objective measures recorded',
        status: 'fully met',
        is_required: false,
      },
      {
        requirement_text: 'Plan progression stated',
        status: 'fully met',
        is_required: false,
      },
    ],
  },
  [IDS.janie]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 1700,
    score: 58,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'ROM measurements documented',
        status: 'not met',
        is_required: false,
        suggestion:
          'Cervical rotation L 55°, R 70°; flexion within normal limits.',
      },
      {
        requirement_text: 'Patient response to treatment',
        status: 'partially met',
        is_required: false,
        suggestion:
          'Symptoms centralizing from forearm to shoulder with traction.',
      },
    ],
  },
  [IDS.jimmy]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 105,
    score: 68,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'ROM measurements documented',
        status: 'not met',
        is_required: false,
        suggestion:
          'Shoulder flexion AROM 110°, abduction 95°, limited by pain at end range.',
      },
      {
        requirement_text: 'Pain level recorded',
        status: 'fully met',
        is_required: false,
      },
    ],
  },
  [IDS.sarah]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 105,
    score: 88,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'Objective measures recorded',
        status: 'fully met',
        is_required: false,
      },
    ],
  },
  [IDS.marcus]: {
    status: 'Transcription Complete!',
    config: 'Progress Note',
    seconds: 105,
    score: 72,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'Progress toward goals quantified',
        status: 'partially met',
        is_required: false,
        suggestion:
          'Hop test LSI improved from 70% to 85%; cutting drills tolerated.',
      },
    ],
  },
  [IDS.elena]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 105,
    score: 90,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'ROM measurements documented',
        status: 'fully met',
        is_required: false,
      },
    ],
  },
  // In-session at load; the Pulse finishes these ~35s into the demo.
  [IDS.derek]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 125,
    score: 92,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'Objective measures recorded',
        status: 'fully met',
        is_required: false,
      },
    ],
  },
  [IDS.priya]: {
    status: 'Transcription Complete!',
    config: 'Daily Note',
    seconds: 125,
    score: 74,
    requirement_evaluations: [
      {
        requirement_text: 'Skilled need documented',
        status: 'fully met',
        is_required: true,
      },
      {
        requirement_text: 'Patient response to treatment documented',
        status: 'not met',
        is_required: false,
        suggestion:
          'First-step pain improved from 6/10 to 4/10 with eccentric loading program.',
      },
    ],
  },
  // Later in the day (1:1 eval + 3:1 group) — scheduled, not yet scored.
  [IDS.tom]: {
    status: 'Scheduled',
    config: 'Eval',
    seconds: 0,
    score: null,
    requirement_evaluations: [],
  },
  [IDS.grace]: {
    status: 'Scheduled',
    config: 'Daily Note',
    seconds: 0,
    score: null,
    requirement_evaluations: [],
  },
  [IDS.omar]: {
    status: 'Scheduled',
    config: 'Daily Note',
    seconds: 0,
    score: null,
    requirement_evaluations: [],
  },
  [IDS.bella]: {
    status: 'Scheduled',
    config: 'Daily Note',
    seconds: 0,
    score: null,
    requirement_evaluations: [],
  },
};

/** In-visit CDS nudges injected ~30s into Jimmy's slot. */
export const JIMMY_CDS_NUDGES = [
  {
    kind: 'nudge',
    source: 'clinical',
    severity: 'warn',
    conversationId: IDS.jimmy,
    patientName: 'Jimmy Rodriguez',
    title: 'Ask Jimmy about his RTM exercises',
    detail: '3 missed home sessions this week — adherence dropped from 95%',
    proposedText: null,
  },
  {
    kind: 'nudge',
    source: 'clinical',
    severity: 'info',
    conversationId: IDS.jimmy,
    patientName: 'Jimmy Rodriguez',
    title: 'Consider Hawkins-Kennedy + ER ROM screen',
    detail:
      'Limited ROM progress 2 visits — differentiate impingement vs early adhesive capsulitis',
    proposedText: null,
  },
];
